import clsx from 'clsx';
import React, { useEffect, useState } from 'react';
import { Transition } from '@headlessui/react';
import { useToast } from '@/hooks/useToast';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const ToastComponent = _ref => {
  let {
    toast
  } = _ref;
  const {
    removeToast
  } = useToast();
  const {
    0: shouldShow,
    1: setShouldShow
  } = useState(false);
  useEffect(() => {
    if (!shouldShow) {
      setShouldShow(true);
    }
  }, [shouldShow]);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShouldShow(false);
      setTimeout(() => {
        removeToast(toast.id);
      }, 1000);
    }, 3500);
    return () => {
      clearTimeout(timer);
    };
  }, [toast.id, removeToast]);

  const icon = () => {
    switch (toast.type) {
      case 'success':
        return /*#__PURE__*/_jsx("svg", {
          className: clsx(styles.iconContainer__icon, styles['iconContainer__icon--success']),
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /*#__PURE__*/_jsx("path", {
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            d: "M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
          })
        });

      case 'warning':
        return /*#__PURE__*/_jsx("svg", {
          className: clsx(styles.iconContainer__icon, styles['iconContainer__icon--warning']),
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /*#__PURE__*/_jsx("path", {
            d: "M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        });

      case 'error':
        return /*#__PURE__*/_jsx("svg", {
          className: clsx(styles.iconContainer__icon, styles['iconContainer__icon--error']),
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /*#__PURE__*/_jsx("path", {
            d: "M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        });

      default:
        return /*#__PURE__*/_jsx("svg", {
          className: styles.iconContainer__icon,
          fill: "none",
          viewBox: "0 0 24 24",
          stroke: "currentColor",
          children: /*#__PURE__*/_jsx("path", {
            d: "M13 16H12V12H11M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z",
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })
        });
    }
  };

  return /*#__PURE__*/_jsx("div", {
    // className="flex items-end justify-center px-4 pt-6 pb-3 pointer-events-none sm:px-6 sm:items-start sm:justify-end"
    className: styles.wrapper,
    children: /*#__PURE__*/_jsx(Transition, {
      show: shouldShow,
      enter: styles.enter,
      enterFrom: styles['enter--from'],
      enterTo: styles['enter--to'],
      leave: styles.leave,
      leaveFrom: styles['leave--from'],
      leaveTo: styles['leave--to'],
      className: styles.container,
      children: /*#__PURE__*/_jsxs("div", {
        className: styles.toast,
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.iconContainer,
          children: icon()
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.content,
          children: [/*#__PURE__*/_jsx("p", {
            className: styles.content__title,
            children: toast.title
          }), /*#__PURE__*/_jsx("p", {
            className: styles.content__description,
            children: toast.description
          })]
        })]
      })
    })
  }, toast.id);
};

export default ToastComponent;